/**
 * Utility to map emoji icons from experienceTypesV2 to FontAwesome icons
 * This allows us to keep emojis in the data but render FontAwesome icons in the UI
 */
import { 
  faScroll,
  faWineGlass,
  faFire,
  faSun,
  faRing,
  faScissors,
  faBaby,
  faAppleWhole,
  faStar,
  faMask,
  faCampground,
  faTree,
  faMoon,
  faGift
} from '@fortawesome/free-solid-svg-icons';

const emojiToIconMap = {
  '📜': faScroll,      // Bar/Bat Mitzvah, Torah study
  '🍷': faWineGlass,    // Passover
  '🕯️': faFire,        // Shabbat, Havdalah, Yahrzeit (using fire as candle alternative)
  '☀️': faSun,         // Rosh Hashanah
  '💍': faRing,        // Wedding
  '✂️': faScissors,    // Bris
  '👶': faBaby,        // Baby naming
  '🍎': faAppleWhole,  // Rosh Hashanah (alternative)
  '🕎': faStar,        // Hanukkah (using star as menorah alternative)
  '🎭': faMask,        // Purim
  '🏕️': faCampground, // Sukkot
  '🌳': faTree,        // Tu B'Shevat
  '🔥': faFire,        // Lag B'Omer
  '🌙': faMoon,        // Rosh Chodesh
};

/**
 * Get FontAwesome icon for an emoji icon string
 * @param {string} emojiIcon - The emoji icon string from experienceTypesV2
 * @returns {object} FontAwesome icon object
 */
export const getExperienceTypeIcon = (emojiIcon) => {
  return emojiToIconMap[emojiIcon] || faGift; // Default to gift icon
};
